module.exports = __webpack_public_path__ + "static/img/trend-1.4b04a425.png";